import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const FOCUS = ["Desire", "Confidence", "Sensuality", "Kink & Fantasy", "Pleasure", "Connection", "Body awareness", "Curiosity"];

export default function Intake() {
  const [form, setForm] = useState({
    pronouns: "", identity: "", experience_level: "",
    focus_areas: [], intentions: "", boundaries: "",
    kinks_interests: "", health_notes: "", contact_preference: "email",
    consent_confidentiality: false,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => { api.get("/intake").then(r => { if (r.data && Object.keys(r.data).length) setForm({ ...form, ...r.data }); }); }, []); // eslint-disable-line

  const toggle = (v) => setForm({ ...form, focus_areas: form.focus_areas.includes(v) ? form.focus_areas.filter(x => x !== v) : [...form.focus_areas, v] });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.consent_confidentiality) return toast.error("Please confirm confidentiality acknowledgment.");
    setLoading(true);
    try {
      await api.post("/intake", form);
      toast.success("Intake saved discreetly.");
    } catch { toast.error("Save failed."); } finally { setLoading(false); }
  };

  return (
    <div data-testid="intake-page" className="max-w-3xl mx-auto px-6 sm:px-10 py-16">
      <div className="eyebrow-lg text-center">Boundaries &amp; Consent</div>
      <h1 className="mt-8 h-editorial text-5xl sm:text-6xl text-center">Tell me <span className="italic-serif text-[#D4AF37]">what you&apos;re curious about.</span></h1>
      <p className="mt-6 max-w-xl mx-auto text-center text-zinc-400 leading-relaxed">Every field is optional except consent. Share what feels right. You can update or withdraw anything at any time — before, during, or after we meet.</p>

      <form onSubmit={submit} data-testid="intake-form" className="mt-14 space-y-8">
        <div className="grid md:grid-cols-2 gap-6">
          <div><label className="eyebrow eyebrow-blue block mb-2">Pronouns</label>
            <input data-testid="intake-pronouns" value={form.pronouns} onChange={e => setForm({...form, pronouns: e.target.value})} className="w-full px-4 py-3" placeholder="he/him" /></div>
          <div><label className="eyebrow eyebrow-blue block mb-2">Identity (open-ended)</label>
            <input data-testid="intake-identity" value={form.identity} onChange={e => setForm({...form, identity: e.target.value})} className="w-full px-4 py-3" placeholder="gay / bi / queer / questioning" /></div>
        </div>

        <div>
          <label className="eyebrow eyebrow-blue block mb-2">Experience with this kind of work</label>
          <select data-testid="intake-experience" value={form.experience_level} onChange={e => setForm({...form, experience_level: e.target.value})} className="w-full px-4 py-3 bg-transparent">
            <option value="" className="bg-[#0B0C10]">Select</option>
            <option value="none" className="bg-[#0B0C10]">First time</option>
            <option value="some" className="bg-[#0B0C10]">Some — therapy or coaching</option>
            <option value="deep" className="bg-[#0B0C10]">Deep — somatic / kink-informed</option>
          </select>
        </div>

        <div>
          <label className="eyebrow eyebrow-blue block mb-3">What you&apos;d like to work on</label>
          <div className="flex flex-wrap gap-2">
            {FOCUS.map(f => (
              <button type="button" data-testid={`focus-${f.replace(/\s|\//g, "").toLowerCase()}`} key={f} onClick={() => toggle(f)} className={`px-4 py-2 rounded-full text-xs font-mono-eyebrow uppercase tracking-[0.15em] border transition-all ${form.focus_areas.includes(f) ? "bg-[#0052FF] border-[#0052FF] text-white" : "border-white/15 text-zinc-400 hover:border-[#00D1FF]/50 hover:text-white"}`}>{f}</button>
            ))}
          </div>
        </div>

        <div><label className="eyebrow-lg block mb-3">Intentions for our experience</label>
          <textarea data-testid="intake-intentions" rows={4} value={form.intentions} onChange={e => setForm({...form, intentions: e.target.value})} className="w-full px-4 py-3" placeholder="What would feel like an awakening?" /></div>

        <div><label className="eyebrow-lg block mb-3">Boundaries &amp; hard limits</label>
          <textarea data-testid="intake-boundaries" rows={3} value={form.boundaries} onChange={e => setForm({...form, boundaries: e.target.value})} className="w-full px-4 py-3" placeholder="What's not on the table today?" /></div>

        <div><label className="eyebrow-lg block mb-3">Kinks &amp; curiosities (optional)</label>
          <textarea data-testid="intake-kinks" rows={3} value={form.kinks_interests} onChange={e => setForm({...form, kinks_interests: e.target.value})} className="w-full px-4 py-3" placeholder="Only if you want to name them." /></div>

        <div><label className="eyebrow-lg block mb-3">Health &amp; accessibility notes</label>
          <textarea data-testid="intake-health" rows={3} value={form.health_notes} onChange={e => setForm({...form, health_notes: e.target.value})} className="w-full px-4 py-3" placeholder="Anything I should know for your comfort." /></div>

        <label className="flex gap-3 items-start text-xs text-zinc-400 leading-relaxed cursor-pointer">
          <input data-testid="intake-consent" type="checkbox" checked={form.consent_confidentiality} onChange={e => setForm({...form, consent_confidentiality: e.target.checked})} className="mt-1" />
          I understand this intake is private, held only by Rebel, and can be deleted at any time. Consent is ongoing and can be updated or withdrawn at any moment. I am 21+.
        </label>

        <button data-testid="intake-submit-btn" type="submit" disabled={loading} className="rc-btn-primary disabled:opacity-50">{loading ? "Saving…" : "Save Intake"}</button>
      </form>
    </div>
  );
}
